(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartCareTeamController', ChartCareTeamController);

    ChartCareTeamController.$inject = ['chart', 'ChartCareTeam', 'CoreService', '$sessionStorage', '$uibModal',
        'access', 'ACTIONS', 'Auth', 'ConfirmationService'];

    function ChartCareTeamController(chart, ChartCareTeam, CoreService, $sessionStorage, $uibModal,
                                     access, ACTIONS, Auth, ConfirmationService) {
        var vm = this;

        vm.chart = chart;
        vm.careTeamsActive = [];
        vm.careTeamsInactive = [];

        vm.toggleItem = toggleItem;
        vm.add = add;
        vm.edit = edit;
        vm.del = del;

        function toggleItem() {
            CoreService.togglePanel('careTeam');
        }

        vm.activeTab = $sessionStorage.activePatientTabCareTeam ? $sessionStorage.activePatientTabCareTeam.activeTab : 0;

        vm.keepActiveTab = function (index) {
            $sessionStorage.activePatientTabCareTeam = {activeTab: index};
            vm.activeTab = index;
        }

        loadData();

        function loadData() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_CARE_TEAM_VIEW, access)) {
                return;
            }

            ChartCareTeam.getAllByFilter({
                chartId: vm.chart.id,
                active: true,
                page: 0,
                size: 100
            }, function (result, headers) {
                vm.careTeamsActive = result;
            });

            ChartCareTeam.getAllByFilter({
                chartId: vm.chart.id,
                active: false,
                page: 0,
                size: 100
            }, function (result, headers) {
                vm.careTeamsInactive = result;
            });
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/chart-care-team/update/chart-care-team-dialog.html',
                controller: 'ChartCareTeamDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {
                            allergen: null,
                            allergen_type: null,
                            reaction: null,
                            treatment: null,
                            status: null,
                            id: null,
                            endDate: null,
                            startDate: null,
                            chart: chart
                        };
                    }
                }
            }).result.then(function () {
                loadData()
            }, function () {
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/chart-care-team/update/chart-care-team-dialog.html',
                controller: 'ChartCareTeamDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['ChartCareTeam', function (ChartCareTeam) {
                        return ChartCareTeam.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadData();
            }, function () {
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Care Team').result.then(function () {
                ChartCareTeam.delete({id: id}, function () {
                    loadData();
                });
            })
        }
    }
})();
